import { Alert, Button, Card } from "flowbite-react";
import { CVS, SURVEYS, USERS } from "../../config/apiConfig";
import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import TitleStripe from "../common/TitleStripe";
import axios from "../../config/axiosInstance";
import moment from "moment/moment";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useNavigate } from "react-router-dom";
import { generateCommunicateSellPdf } from "../../utils/pdf-cv.exporter";

const ReviewData = ({ setActiveStep, communicateSell, setCommunicateSell }) => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [submittedCV, setSubmittedCV] = useState(null);
  const [error, setError] = useState(null);

  const onBack = async () => {
    setActiveStep(4);
  };

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const response = await axios.post(`${CVS.GET_CV}`, communicateSell);
      setSubmittedCV(response.data);
      setCommunicateSell(response.data);

      if (response.data.erro) {
        setError(response.data.erro);
      } else {
        setIsSubmitted(true);
      }
    } catch (error) {
      console.log(error);
      setError(
        error?.response?.data?.message ||
          "Erro ao tentar criar comunicado de venda!"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      {!isSubmitted ? (
        <div>
          <div className="flex flex-col gap-2 mt-5">
            <TitleStripe>Dados do veículo</TitleStripe>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Placa:</div>
                <div>{communicateSell?.placa}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Renavam:</div>
                <div>{communicateSell?.renavam}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Ano Fabricação/Modelo:</div>
                <div>
                  {communicateSell?.anoFabricacao}/{communicateSell?.anoModelo}
                </div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Tipo do CRV:</div>
                <div>{communicateSell?.tipoCRV}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Número do CRV:</div>
                <div>{communicateSell?.numeroCRV}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Número Via CRV:</div>
                <div>{communicateSell?.numeroViaCRV}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Data de emissão do CRV:</div>
                <div>
                  {moment(communicateSell?.dataEmissaoCRV).format("DD/MM/yyyy")}
                </div>
              </div>
            </div>
            <TitleStripe>Dados da venda</TitleStripe>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Data da venda:</div>
                <div>
                  {moment(communicateSell?.dataVenda).format("DD/MM/yyyy")}
                </div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">UF da venda:</div>
                <div>{communicateSell?.ufVenda}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">
                  Código do município da venda:
                </div>
                <div>{communicateSell?.codigoMunicipioVenda}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Nome do informante:</div>
                <div>{communicateSell?.nomeVendedor}</div>
              </div>
              {communicateSell?.telefoneInformante && (
                <div className="flex gap-2 items-center">
                  <div className="font-semibold">Telefone do informante:</div>
                  <div>{communicateSell?.telefoneInformante}</div>
                </div>
              )}
            </div>
            <TitleStripe>Dados do comprador</TitleStripe>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Nome do comprador:</div>
                <div>{communicateSell?.nomeComprador}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Documento do comprador:</div>
                <div>{communicateSell?.cpfCnpjComprador}</div>
              </div>
              {communicateSell?.telefoneComprador && (
                <div className="flex gap-2 items-center">
                  <div className="font-semibold">Telefone do comprador:</div>
                  <div>{communicateSell?.telefoneComprador}</div>
                </div>
              )}

              <div className="flex gap-2 items-center">
                <div className="font-semibold">CEP do comprador:</div>
                <div>{communicateSell?.cepComprador}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Endereço do comprador:</div>
                <div>{communicateSell?.logradouroComprador}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Bairro do comprador:</div>
                <div>{communicateSell?.bairroComprador}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Número:</div>
                <div>{communicateSell?.numeroEnderecoComprador}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Complemento do comprador:</div>
                <div>
                  {communicateSell?.complementoComprador || "Sem complemento"}
                </div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">
                  Código do município do comprador:
                </div>
                <div>{communicateSell?.codigoMunicipioComprador}</div>
              </div>
            </div>
            <TitleStripe>Dados do vendedor</TitleStripe>
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-2">
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Nome do vendedor:</div>
                <div>{communicateSell?.nomeVendedor}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Documento do vendedor:</div>
                <div>{communicateSell?.cpfCnpjVendedor}</div>
              </div>
              {communicateSell?.telefoneVendedor && (
                <div className="flex gap-2 items-center">
                  <div className="font-semibold">Telefone do vendedor:</div>
                  <div>{communicateSell?.telefoneVendedor}</div>
                </div>
              )}

              {/* <div className="flex gap-2 items-center">
                <div className="font-semibold">CEP do vendedor:</div>
                <div>{communicateSell?.logradouroVendedor}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Bairro do vendedor:</div>
                <div>{communicateSell?.bairroVendedor}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Número do vendedor:</div>
                <div>{communicateSell?.numeroEnderecoVendedor}</div>
              </div>
              <div className="flex gap-2 items-center">
                <div className="font-semibold">Município do vendedor:</div>
                <div>{communicateSell?.codigoMunicipioVendedor}</div>data
              </div> */}
            </div>
          </div>
          <div className="flex justify-center items-center gap-2 mt-10">
            <Button
              className="bg-gray-500"
              onClick={onBack}
              style={{ minWidth: "90px" }}
            >
              Voltar
            </Button>
            <Button
              className="primary"
              disabled={isSubmitting}
              isProcessing={isSubmitting}
              onClick={onSubmit}
            >
              {!isSubmitting ? "Emitir comunicado" : "Salvando..."}
            </Button>
          </div>
          {error && (
            <>
              <Alert color="failure" withBorderAccent className="mt-4">
                {error}
              </Alert>
            </>
          )}
        </div>
      ) : (
        <div className="flex flex-col gap-2 mt-10 mb-10 justify-center items-center">
          <div className="w-48 mx-auto">
            <DotLottieReact
              src="https://lottie.host/94b2946b-3008-4b12-9222-54c8265d23da/CGohAzrvbF.lottie"
              autoplay
            />
          </div>
          <div className="flex flex-col justify-center gap-4">
            <div className="text-center text-base md:text-lg font-semibold">
              Comunicado de venda enviado com sucesso!
            </div>
            <div className="flex justify-center gap-2">
              <Button
                className="w-fit"
                onClick={() => generateCommunicateSellPdf(submittedCV)}
              >
                Salvar recibo
              </Button>
              <Button
                className="w-fit min-w-32 bg-gray-500"
                onClick={() => navigate("/cvs")}
              >
                Voltar
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewData;
